import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import TouchAppIcon from "@mui/icons-material/TouchApp";
import { ClickActionEvent } from '../../util/analytics'

import projects from "./Data"
import LoadingImage from '../LoadingImage';
 



export default function Projects() {
  const sxCard = { height: '100%', display: 'flex', flexDirection: 'column' };
  const sxCardHover = { ...sxCard, boxShadow: '0 4px 8px 0 rgba(0,0,255,0.8), 0 6px 20px 0 rgba(0,0,255,0.8)', cursor: 'pointer', opacity: 0.7, transition: '0.2s linear' };
  const sxCardMedia = { paddingTop: '22.25%', height: 70 };
  const sxCardContent = { flexGrow: 1 };

  const [selectedProject, setSelectedProject] = React.useState('')
  const [showAllProjects, setShowAllProjects] = React.useState(false)
  const visibleProjects = showAllProjects ? projects : projects.slice(0, 0)

  const MouseOver = (t)  =>{
    setSelectedProject(t)
    
  }

  const MouseOut = (event)  =>{
    setSelectedProject('')
  }

  return (
    <React.Fragment>
 
      <div style={{backgroundColor:"#033736"}}>

        <Box sx={{ py: 10, backgroundColor: '#033736' }}>
          <Container maxWidth="md">
            <Typography component="h1" variant="h3" align="center" color="textPrimary" style={{color:"#37beb0"}} gutterBottom>
              POCs in React-Node 💻
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" style={{color:"#37beb0"}} paragraph>
              These are some POCs done using react, node, postgres, sqllite, firebase, indexDb, material/semantic ui.
              To know about professional projects I have worked on, please refer to my <a style={{color: "#b8b6f0"}} href='https://www.linkedin.com/in/javed-akhtar-07370613b/details/experience/'>linkedIn</a> profile.
            </Typography>
          </Container>
        </Box>
        <Container sx={{ pt: 0, pb: 8 }} maxWidth="lg" >
          <Grid container spacing={4}>
            {visibleProjects.map((project) => (
              <Grid item key={project.id} xs={12} sm={6} md={4}>
               <Link href={project.deployedLink} target="_blank" rel="noreferrer noopener" onClick={()=>{ClickActionEvent('Project '+project.name, 'projects section', 'project clicked')}}> 
                <Card sx={project.name===selectedProject?sxCardHover:sxCard} style={{backgroundColor:"#0abab5"}} onMouseOver={()=>MouseOver(project.name)} onMouseOut={MouseOut}>
                  
                  <LoadingImage
                    sx={sxCardMedia}
                    src={process.env.PUBLIC_URL + project.image}
                    alt={project.name}
                  />
                  
                  <CardContent sx={sxCardContent}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {project.name} <TouchAppIcon/>
                    </Typography>
                    <Typography>
                      {project.description}
                    </Typography>
                  </CardContent>
                </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setShowAllProjects((prev) => !prev)}
            >
              {showAllProjects ? 'Show less' : 'Show POC projects'}
            </Button>
          </Box>
        </Container>
      </div>
    </React.Fragment>
  );
}
